<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: [
    'id',
    'inverse'
  ],

  computed: {
    ...mapState({
      current: state =>
        state.reservation.current,
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
    }),

    editUrl: function () {
      return Labstack.url + '/topologies/' + this.id + '/edit'
    },
    reservationEditUrl: function () {
      if(this.reservation_transaction == undefined) {
        return ''
      }

      let id = this.reservation_transaction.attributes.topology_blueprint_id

      return Labstack.url + '/topologies/' + id + '/edit'
    },
    isDisabled: function () {
      return this.current.is_loading || this.editUrl == this.reservationEditUrl
    }
  }
}
</script>

<template>
  <span>
    <a a class="btn click-prevent" :href="editUrl" :class="{ 'disabled': isDisabled, 'btn-warning': !inverse, 'btn-inverse btn-outline': inverse }">
      <i class="fa fa-edit"></i>&nbsp;&nbsp;
      Edit
    </a>&nbsp;
  </span>
</template>
